export const UPDATE_COMPANIES ="update_companies"
export const UPDATE_GROUPS="update_groups"
export const DELETE_GROUP_BYID="delete_group_byid"
export const DELETE_COMPANY_BYID="delete_company_byid"